import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import classNames from '../../utils/classNames'
import { numberWithCommas } from '../../utils/number'
import type { Item } from '../common/scroll-selector'

export type Promo = Item & {
  content: string
  bonus_amount: number
  total_credit_amount: number
}

interface PromotionInputProps {
  selectedPromo: Promo | null
  onPromoSelect: (promo: Promo) => void
  promoList: Promo[]
}

const Amount = ({ children } : { children: ReactNode }) => (
  <p className="lg:text-lg text-secondary-txt [&_span]:text-txt">{children}</p>
)

const PromotionInput = ({
  selectedPromo,
  promoList,
  onPromoSelect,
}: PromotionInputProps) => {
  const { t } = useTranslation('walletManagement')

  return (
    <div className="mb-5">
      <div className="flex gap-2 items-start flex-nowrap overflow-x-auto overflow-y-hidden">
        {promoList.map(promo => (
          <button
            key={promo.id}
            className={classNames(
              'w-[140px] lg:w-[180px] min-w-[140px] lg:min-w-[180px] p-2.5 text-left rounded-md border border-txt transition-all duration-200 ease-in-out disabled:opacity-70',
              selectedPromo?.id === promo.id ? 'bg-highlight' : 'bg-tertiary')}
            onClick={() => onPromoSelect(promo)}>
            <p className="text-xs lg:text-sm text-txt leading-4 lg:leading-[18px] uppercase font-Geometr706-BlkCn-BT">
              {promo.label}
            </p>
          </button>
        ))}
      </div>
      {selectedPromo && selectedPromo.id !== 0 && (
        <div
          className="flx-str-ctr mt-4"
          style={{
            flexWrap: 'wrap',
            gap: 12,
            justifyContent: 'space-between',
          }}>
          <Amount>
            {t('bonus-amount')}:{' '}
            <span>${numberWithCommas(+selectedPromo.bonus_amount)}</span>
          </Amount>
          <Amount>
            {t('total-credits')}:{' '}
            <span>${numberWithCommas(+selectedPromo.total_credit_amount)}</span>
          </Amount>
        </div>
      )}
    </div>
  )
}

export default PromotionInput
